var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.11,1.56a1.56,1.56,0,1,0-1.8,1.53V2H.92V1.56h.39V1.21A.54.54,0,0,1,1.9.61a2.47,2.47,0,0,1,.35,0V1h-.2a.22.22,0,0,0-.25.24v.3h.43L2.16,2H1.8V3.09A1.55,1.55,0,0,0,3.11,1.56Z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 3.11 3.09"};

module.exports = Facebook;

Facebook.default = Facebook;
